"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.DivErrorPage = styled_components_1.default.div `
  background-color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  padding: 0px 30px;
  text-align: center;
  min-height: 300px;
`;
exports.ImgEmpty = styled_components_1.default.img `
  height: 72px;
  width: 78.8px;
  padding: 10px;
  margin-top: 12vh;
`;
exports.ImgGeneral = styled_components_1.default.img `
  width: 168px;
  padding-bottom: 35px;
  margin-top: 15vh;
`;
exports.Button = styled_components_1.default.button `
  background-color: white;
  border: 1px solid #ee4d2d;
  color: #ee4d2d;
  padding: 10px 30vw;
  font-size: 14px;
  font-weight: 400;
  margin: 30px 0px;
  border-radius: 4px;

  @media (min-width: 600px) {
    padding: 10px 120px;
  }
`;
//# sourceMappingURL=Style.js.map